import i18n from "@/Language/i18n";
import { ifRouterRedirect, lazyWithErrorHandle } from "@/utils/utils";
import title from "./title";

export default {
  path: "/overseasMenu",
  meta: {
    title: title(i18n.t("Overseas_Menu")),
    roles: ["overseasMenu"],
  },
  redirect: ifRouterRedirect("overseasMenu"),
  children: [
    {
      path: "overseasMenu-userViewScreen",
      meta: {
        title: i18n.t("User_Overview_Screen"), // 用户一栏画面
        roles: ["overseasMenu-userViewScreen"],
      },
      component: lazyWithErrorHandle(() => import("@/pages/UserViewScreen")),
    },
    {
      path: "overseasMenu-firmAdmin", // 事業・業態リスト
      meta: {
        title: i18n.t("FirmAdmin_router_name"),
        roles: ["overseasMenu-firmAdmin"],
      },
      component: lazyWithErrorHandle(() => import("@/pages/FirmAdmin")),
    },
    {
      path: "overseasMenu-developMaster", // ディベロッパーマスタ
      meta: {
        title:
          JSON.parse(sessionStorage.getItem("userInfo")!)?.countryCD === "00"
            ? i18n.t("DevelopMasterPage_title")
            : i18n.t("DevelopMasterPage_title_ntJP"),
        roles: ["overseasMenu-developMaster"],
      },
      component: lazyWithErrorHandle(() => import("@/pages/DevelopMaster")),
    },
    {
      path: "overseasMenu-regionalManagement", // 地区管理
      meta: {
        title:
          JSON.parse(sessionStorage.getItem("userInfo")!)?.countryCD === "00" ? i18n.t("regional_management") : i18n.t("regional_management_ntJP"),
        roles: ["overseasMenu-RegionalManagement"],
      },
      component: lazyWithErrorHandle(() => import("@/pages/AreaAdmin")),
    },
  ],
};
